import { render, staticRenderFns } from "./NavbarConfig.vue?vue&type=template&id=e827cc28&scoped=true"
import script from "./NavbarConfig.vue?vue&type=script&lang=js"
export * from "./NavbarConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e827cc28",
  null
  
)

export default component.exports